export default __webpack_public_path__ + "static/media/ic_banxa.06412144.svg";